export function getPlatformProfileDisplayName(profile) {
  const firstName = profile?.user?.first_name || "";
  const lastName = profile?.user?.last_name || "";
  const fullName = `${firstName} ${lastName}`.trim();

  return fullName || profile?.user?.email || "";
}

export function isPlatformRestrictedProfile(profile) {
  return false;
}

export function buildPlatformCustomerScopeParams(profile, params = {}) {
  return { ...params };
}

export async function fetchPlatformAssignedCustomers(profile, params = {}) {
  return [];
}